class MenuScroll extends window.BAO.CustomElement() {
  connectedCallback () {
    if (this.els?.child?.elements?.length < 2) return

    this.setupListeners()
  }

  setupListeners () {
    this.els?.child?.elements.forEach(child => {
      child.addEventListener('click', () => {
        const parentRect = this.els?.parent?.exists ? this.els.parent.element.getBoundingClientRect() : this.getBoundingClientRect()

        const rect = child.getBoundingClientRect()

        const relativeLeft = rect.left - parentRect.left
        const inlinePosition = relativeLeft < parentRect.width / 2 ? 'end' : 'start'

        // Scroll the child into view with the calculated alignment
        child.scrollIntoView({
          behavior: 'smooth',
          inline: inlinePosition,
          block: 'nearest', // Set block to 'nearest' to prevent vertical scrolling
        })
      })

      // Check if child has active class assigned
      if (child.classList.contains('pg-GuidesNav_Guide-active')) {
        // Scroll the active child into view
        child.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center',
        })
      }
    })
  }
}

if (!customElements.get('menu-scroll')) {
  customElements.define('menu-scroll', MenuScroll)
}
